import React, { useEffect, useState, useRef } from "react";
import { TextField } from "@material-ui/core";
import { useTranslation } from "../../langs/useTranslation";
import CompanyTreeModal from "../CompanyTree/Modal";
import localforage from "localforage";

function getCompanyMap() {
  return JSON.parse(sessionStorage.getItem("companiesMap") || "{}");
}

const CompanySelector = ({ onSelect, companyId }) => {
  const [companyTreeModalOpen, setCompanyTreeModalOpen] = useState(false);
  const [companyName, setCompanyName] = useState(() => {
    return getCompanyMap()[companyId] || "";
  });
  const { t } = useTranslation();

  const handleClick = () => {
    setCompanyTreeModalOpen(true);
  };

  const handleClose = () => setCompanyTreeModalOpen(false);

  const handleCompanySelect = (selectedKey, selectedNode) => {
    const nodeName = selectedNode.node.name;
    setCompanyName(nodeName);
    handleClose();
    onSelect?.(selectedKey, selectedNode);
    const prevCompanyMap = getCompanyMap();
    sessionStorage.setItem(
      "companiesMap",
      JSON.stringify({
        ...prevCompanyMap,
        [selectedKey[0]]: nodeName
      })
    );
  };

  useEffect(() => {
    if (companyId) {
      const name = getCompanyMap()[companyId] || "";
      if (name) {
        setCompanyName(name);
      } else {
        localforage.getItem("userCompanyName").then(setCompanyName);
      }
    }
  }, [companyId]);

  return (
    <>
      <TextField
        variant="outlined"
        label={t({ defaultMessage: "选择公司" })}
        value={companyName}
        style={{ width: 342 }}
        readOnly
        size="small"
        onClick={handleClick}
      />
      <CompanyTreeModal
        open={companyTreeModalOpen}
        // companyId={companyId}
        checkable={false}
        footer={null}
        onClose={handleClose}
        onSelect={handleCompanySelect}
      />
    </>
  );
};

export default CompanySelector;
